document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".find-your-mat .find-your-mat-grid");
  const slides = slider?.querySelectorAll(".mat-item") || [];
  const dotsCtr = document.querySelector(
    ".find-your-mat .mat-dots-wrapper .mat-dots"
  );
  if (!slider || slides.length === 0 || !dotsCtr) return;

  dotsCtr.style.pointerEvents = "auto";

  slides.forEach((slide, i) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "mat-dot";
    btn.addEventListener("click", () => {
      slider.scrollTo({
        left: slide.offsetLeft - slider.offsetLeft,
        behavior: "smooth",
      });
    });
    dotsCtr.appendChild(btn);
  });

  const dots = Array.from(dotsCtr.children);
  const activate = (idx) =>
    dots.forEach((d, j) => d.classList.toggle("active", j === idx));

  activate(0);

  slider.addEventListener("scroll", () => {
    const sliderRect = slider.getBoundingClientRect();
    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, i) => {
      const slideRect = slide.getBoundingClientRect();
      // distance between the *visible* left edges
      const distance = Math.abs(slideRect.left - sliderRect.left);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = i;
      }
    });

    activate(closestIndex);
  });

  // --- desktop grab-and-drag support ---
  let isDown = false,
    startX,
    scrollLeft;
  slider.style.cursor = "grab";
  slider.style.userSelect = "none"; // prevent text selection

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.style.cursor = "grabbing";
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    e.preventDefault();
  });
  slider.addEventListener("mouseleave", () => {
    isDown = false;
    slider.style.cursor = "grab";
  });
  slider.addEventListener("mouseup", () => {
    isDown = false;
    slider.style.cursor = "grab";
  });
  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = x - startX;
    slider.scrollLeft = scrollLeft - walk;
  });
});
